import { request } from './request';
import { api_config } from '@/constants/api';
import Utils from '../utils/index';
let apiUrlV2 = api_config.API_V2_URL;
let apiGoogleUrl = api_config.googleUrl;
/**
 * 请求游客token
 * @param {object} 请求参数
 */
const requsetGetAnonymousSessions = () => {
  const options = {
    method: 'POST',
  };
  return new Promise((resolve, reject) => {
    request(apiUrlV2 + 'tmp-sessions', options, true)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 请求用户信息
 * @param {object} 请求参数
 */
const requsetGetProfile = () => {
  const options = {
    method: 'GET',
  };
  return new Promise((resolve, reject) => {
    request(apiUrlV2 + 'accounts/profile', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 请求获取用户订阅信息
 * @param {object} 请求参数
 */
const requsetGetSubscription = (data) => {
  const options = {
    data,
    method: 'GET',
  };
  return new Promise((resolve, reject) => {
    request(apiUrlV2 + 'accounts/subscription', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 请求获取用户订阅信息
 * @param {object} 请求参数
 */
const requsetGetPurchase = (params) => {
  const options = {
    ...params,
    method: 'POST',
  };
  return new Promise((resolve, reject) => {
    request(apiUrlV2 + 'check-out', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const requestDownload = (params) => {
  const option = {
    ...params,
    method: 'POST',
  };
  return new Promise((resolve, reject) => {
    request(apiUrlV2 + 'dynamicPhoto/download', option)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
/**
 * 请求获取用户主题信息
 * @param {object} 请求参数
 */
const requsetGetAppearance = (params) => {
  const options = {
    ...params,
    method: 'GET',
  };
  return new Promise((resolve, reject) => {
    request(apiUrlV2 + 'preferences', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const checkGoogleSafe = (params) => {
  const formData = new FormData();
  const { email, code, token, id } = params;
  formData.append('email', email);
  formData.append('code', code);
  formData.append('token', token);
  formData.append('id', id);
  const options = {
    method: 'POST',
    body: formData,
  };
  return new Promise((resolve, reject) => {
    request(apiUrlV2 + 'google/check-email', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 谷歌回调
 */

const googleCallback = (params) => {
  const formData = new FormData();
  formData.append('code', params.code);
  formData.append('state', params.state);
  formData.append('refer', `HitPaw_Online_Embedded_${Utils.getLanguage()}`);
  const options = {
    method: 'POST',
    body: formData,
  };
  return new Promise((resolve, reject) => {
    request(apiUrlV2 + 'google/callback', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const loginWithToken = (formData) => {
  const options = {
    method: 'POST',
    body: formData,
  };
  return new Promise((resolve, reject) => {
    request(apiUrlV2 + 'login/with-token', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 获取google state
 * @param  params
 * @returns
 */

const getGoogleState = (params) => {
  const options = {
    ...params,
    method: 'GET',
  };
  return new Promise((resolve, reject) => {
    request(apiGoogleUrl + 'google/state', options);
  });
};

/**
 * 录屏任务上报
 */

const sendRecorderStatus = (params) => {
  const formData = new FormData();
  formData.append('status', params);
  const options = {
    method: 'POST',
    body: formData,
  };
  return new Promise((resolve, reject) => {
    request(apiUrlV2 + 'report-screen-recording', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export {
  requsetGetAnonymousSessions,
  requsetGetProfile,
  requsetGetSubscription,
  requsetGetPurchase,
  requsetGetAppearance,
  requestDownload,
  checkGoogleSafe,
  googleCallback,
  sendRecorderStatus,
  loginWithToken,
  getGoogleState,
};
